import Vue from 'vue'
import Router from 'vue-router'
import Checkpoint from '@/views/Checkpoint'
import Directions from '@/views/Directions'
import Home from '@/views/Home'
import Stroll from '@/views/Stroll'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/preview/:strollId',
      name: 'preview',
      component: Home,
      props: route => {
        return {
          strollId: route.params.strollId,
          showStrollPreview: true,
        }
      }
    },
    {
      path: '/stroll/:strollId',
      name: 'stroll',
      component: Stroll,
      props: true,
    },
    {
      path: '/directions/:strollId',
      name: 'directions',
      component: Directions,
      props: true,
    },
    {
      path: '/stroll/:strollId/checkpoints/:checkpointId',
      name: 'checkpoint',
      component: Checkpoint,
      props: true,
    },
  ]
})
